import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@nxsys/store';
import { appActions } from '@nxsys/store/slices/app/reducer/appSlice';
import { roleOf } from '@nxsys/store/slices/app/roleOf';

export const useAuthUser = () => {
  const reduxToken = useSelector((state: RootState) => state.appStore.token);
  const reduxUser = useSelector((state: RootState) => state.appStore.user);
  const authCode = useSelector((state: RootState) => state.appStore.authCode);

  // A user stored by a login as has no `role` until /me runs again, so take it
  // from `roles` (NX-5877), not admin.
  const user = reduxUser
    ? {
        ...reduxUser,
        role: reduxUser.role || roleOf(reduxUser),
      }
    : null;

  return {
    isLoading: false,
    isAuthenticated: (!!reduxToken && !!reduxUser) || (!!authCode && !!reduxUser),
    user,
  };
};

export const useAuthMethod = () => {
  const dispatch = useDispatch();

  const logout = () => {
    return dispatch(appActions.logout());
  };

  return {
    logout,
  };
};
